/* CLAYCALI 31/10/26: Mystery Necklace gift layer for cc-p4n (Pick Any N page).
   - Hero: gift box under the price (replaces the plain gift line).
   - "Your Bundle" list + review drawer: gift slot that is locked until all pieces are chosen, then "unlocked".
     The gift is never revealed (no name, no photo of the chain) - she sees it when she opens her box.
   - Mobile/sticky bar: a strip above the bar with the same locked/unlocked message.
   - Cart: the gift is added as its own $0 line next to the bundle (checkout shows "Mystery Necklace - FREE").
     Extra gift lines without a bundle are removed when this page loads. */
(function () {
  if (window.__ccp4m) return; window.__ccp4m = 1;
  var D = {}; try { D = JSON.parse(document.getElementById('ccp4m-data').textContent); } catch (e) { return; }
  var GV = +D.variant; if (!GV) return;

  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  var WORTH = +D.worth || 0, TITLE = D.title || 'Mystery Necklace', TAG = D.tag || '';
  var SUB = String(D.sub || '').replace(/\[worth\]/g, WORTH ? money(WORTH) : '');
  if (!WORTH) SUB = SUB.replace(/\s*·?\s*worth up to\s*$/i, '');

  var GIFT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/><path d="M3 7h18v4H3zM12 7v14"/><path d="M12 7c-2.6 0-4.2-1.1-4.2-2.5S9.6 2 12 7c2.4-5 4.2-3.9 4.2-2.5S14.6 7 12 7z"/></svg>';
  var LOCK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var OPEN_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/><path d="M12 12v9"/><g transform="rotate(-14 12 8)"><path d="M3 6h18v4H3zM12 6v4"/><path d="M12 6c-2.6 0-4.2-1.1-4.2-2.5S9.6 1 12 6c2.4-5 4.2-3.9 4.2-2.5S14.6 6 12 6z"/></g></svg>';

  function start() {
    var root = document.getElementById('ccp4'); if (!root) return;
    var N = +root.dataset.count || 4, BVAR = +root.dataset.variant;
    var lastN = null, fx = false;

    function count() { var el = root.querySelector('[data-p4-count]'), m = el && /(\d+)\s*of\s*(\d+)/.exec(el.textContent); return m ? +m[1] : 0; }
    function worthTag() { return '<div class="p4m-price">' + (WORTH ? '<s>' + money(WORTH) + '</s>' : '') + '<strong>Free</strong></div>'; }

    /* hero */
    var gl = root.querySelector('.p4-giftline');
    if (gl && !root.querySelector('.p4m-hero')) {
      var h = document.createElement('div'); h.className = 'p4m-hero';
      h.innerHTML = '<span class="p4m-ico">' + GIFT_SVG + '</span><div>' + (TAG ? '<span class="p4m-tag">' + esc(TAG) + '</span>' : '') +
        '<p class="p4m-head">' + esc(D.head || ('Free ' + TITLE + ' with every bundle')) + '</p>' + (SUB ? '<p class="p4m-sub">' + esc(SUB) + '</p>' : '') + '</div>';
      gl.parentNode.insertBefore(h, gl);
    }

    /* gift slot (side list + review drawer) */
    function slotHTML(inReview) {
      var n = count(), done = n >= N, left = N - n, sub;
      if (done) sub = esc(D.reveal || 'Revealed when you open your box');
      else sub = n ? 'Choose ' + left + ' more piece' + (left > 1 ? 's' : '') + ' to unlock' : 'Choose your ' + N + ' pieces to unlock';
      var bars = ''; for (var i = 0; i < N; i++) bars += '<i' + (i < n ? ' class="on"' : '') + '></i>';
      return '<span class="p4m-ico">' + (done ? OPEN_SVG : LOCK_SVG) + (done && fx && !inReview ? new Array(7).join('<u class="p4m-spark"></u>') : '') + '</span>' +
        '<div class="p4m-txt">' + (TAG ? '<span class="p4m-tag">' + esc(TAG) + '</span>' : '') +
        '<h4>' + (done ? esc(TITLE) + ' unlocked!' : 'Free ' + esc(TITLE)) + '</h4><p>' + sub + '</p>' +
        (done ? '' : '<span class="p4m-bars" aria-hidden="true">' + bars + '</span>') + worthTag() + '</div>';
    }
    function paintSlots() {
      var n = count(); fx = lastN !== null && lastN < N && n >= N; lastN = n;
      document.querySelectorAll('#ccp4 .p4-slot--gift').forEach(function (el) {
        var inReview = !!el.closest('[data-p4-dlg-body]'), done = n >= N;
        var key = n + (inReview ? 'r' : 's');
        if (el.dataset.p4m === key) return;
        el.dataset.p4m = key;
        el.className = 'p4-slot p4-slot--gift p4m-slot ' + (done ? 'p4m-on' : 'p4m-off') + (done && fx && !inReview ? ' p4m-fx' : '');
        el.innerHTML = slotHTML(inReview);
      });
      paintStrip(n);
    }

    /* strip above the sticky bar */
    var bar = root.querySelector('[data-p4-bar]'), strip = null;
    function paintStrip(n) {
      if (!bar) return;
      if (!strip) { strip = document.createElement('div'); strip.className = 'p4m-strip'; strip.setAttribute('role', 'status'); bar.insertBefore(strip, bar.firstChild); }
      var done = n >= N, left = N - n;
      strip.classList.toggle('p4m-on', done);
      strip.innerHTML = (done ? OPEN_SVG : LOCK_SVG) + (TAG ? '<b>' + esc(TAG) + '</b>' : '') + '<span>' +
        (done ? 'Your free ' + esc(TITLE) + ' is unlocked. ' + esc(D.reveal || '') + '.' : 'Choose ' + (n ? left + ' more piece' + (left > 1 ? 's' : '') : 'your ' + N + ' pieces') + ' to unlock a free ' + esc(TITLE) + '.') + '</span>';
    }

    var mo = new MutationObserver(function () { mo.disconnect(); try { paintSlots(); } finally { observe(); } });
    function observe() {
      var a = root.querySelector('[data-p4-slots]'), b = root.querySelector('[data-p4-dlg-body]'), c = root.querySelector('[data-p4-count]');
      [a, b].forEach(function (x) { if (x) mo.observe(x, { childList: true, subtree: true }); });
      if (c) mo.observe(c, { childList: true, characterData: true, subtree: true });
    }
    paintSlots(); observe();

    /* cart: add the gift as its own $0 line next to the bundle */
    var of = window.fetch;
    window.fetch = function (url, opts) {
      try {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string' && opts.body.indexOf(String(BVAR)) > -1) {
          var b = JSON.parse(opts.body);
          if (b && b.items) {
            var gifts = [];
            b.items.forEach(function (it) {
              if (+it.id !== BVAR) return;
              var p = it.properties || {};
              delete p['Free Gift'];
              gifts.push({ id: GV, quantity: it.quantity || 1, properties: { '_bundle': p._bundle || '', '_bundle_gift': '1', 'Gift': D.line_label || 'Free with your bundle' } });
            });
            if (gifts.length) { b.items = b.items.concat(gifts); opts = Object.assign({}, opts, { body: JSON.stringify(b) }); }
          }
        }
      } catch (e) {}
      return of.call(this, url, opts);
    };

    /* tidy: no more gift lines than bundles in the cart */
    of('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var bundles = 0, gl2 = [];
      (c.items || []).forEach(function (it) { if (it.variant_id === BVAR) bundles += it.quantity; if (it.variant_id === GV) gl2.push(it); });
      var allow = bundles, chain = Promise.resolve();
      gl2.forEach(function (it) {
        var keep = Math.min(it.quantity, allow); allow -= keep;
        if (keep !== it.quantity) chain = chain.then(function () { return of('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: keep }) }); });
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
